var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19567 15.5336L8.4861 1.90169C8.63173 1.62946 8.84963 1.40164 9.11638 1.24275C9.38312 1.08386 9.68861 0.999893 10 0.999893C10.3114 0.999893 10.6169 1.08386 10.8836 1.24275C11.1504 1.40164 11.3683 1.62946 11.5139 1.90169L18.8043 15.5336C18.9412 15.7909 19.0083 16.0788 18.9992 16.3693C18.9901 16.6599 18.905 16.9431 18.7523 17.1915C18.5996 17.4399 18.3845 17.6449 18.1278 17.7865C17.8712 17.9282 17.5819 18.0017 17.288 17.9999H2.70875C2.41514 18.0011 2.1262 17.9272 1.87003 17.7853C1.61385 17.6434 1.39916 17.4384 1.24684 17.1901C1.09453 16.9418 1.00976 16.6588 1.00079 16.3685C0.991827 16.0782 1.05896 15.7906 1.19567 15.5336Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66666V11.6667",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.9999C10.5523 15.9999 11 15.5522 11 14.9999C11 14.4476 10.5523 13.9999 10 13.9999C9.44772 13.9999 9 14.4476 9 14.9999C9 15.5522 9.44772 15.9999 10 15.9999Z",
    fill: "#197C85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alertTriangle.4adf4e3b63dc6c84be70263e0c942fe7.svg";
export { ForwardRef as ReactComponent };